'use strict';

export default {
  organizationMenu: {
    addOrganization: 'Créer votre organisation',
    changeOrganizationSuccess: 'Organisation changée avec succès !',
    changeOrganizationError: "Erreur lors du changement d'organisation !",
    noOrganizations: '*Aucune organisation à afficher',
    modal: {
      name: "Nom de l'organisation",
      avatar: 'Logo',
      addOrganization: 'Créer',
      cancelButton: 'Annuler',
      addOrganizationSuccess: 'Organisation ajoutée avec succès !',
      addOrganizationError: "Error lors de l'ajout de l'organisation",
      chooseAvatar: 'Choisissez un fichier',
      upload: 'Téléverser',
      organizationChange: 'Organisation changée à ',
      organizationChangeBaseText: 'réussie',
      errorName: 'Nom valide requis',
      errorNoName: 'Le nom ne peut pas être vide',
      import: 'Importer une image',
      currency: 'Devise',
    },
  },
};
